import { ReactNode, useCallback, useEffect, useMemo, useReducer } from "react";
import { ConfigurationsContextAction, ConfigurationsContextActionType, ConfigurationsStateType } from "./ConfigurationsContextTypes";
import { ConfigurationsContext } from "./ConfigurationsContext";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { SideSheetGroupedSelectOptionGroup } from "../../components/side-sheet/side-sheet-grouped-select/SideSheetGroupedSelect";
import { CONFIGURATION_RESET_TOPIC } from "../../common/models/pub-sub/PubSubTopics";
import { publish } from "pubsub-js";

const reducer = (state: ConfigurationsStateType, action: ConfigurationsContextAction): ConfigurationsStateType => {
    switch (action.type) {

        case ConfigurationsContextActionType.ConfigurationsChanged:
            return {
                ...state,
                configurations: action.payload
            };

        case ConfigurationsContextActionType.ConfigurationChanged:

            return {
                ...state,
                configurationID: action.payload
            };

        case ConfigurationsContextActionType.ResetChanged:

            publish(CONFIGURATION_RESET_TOPIC);

            return {
                ...defaultConfigurationsState
            }            

        default:
            return state;
    }
};

export type ConfigurationsContextProviderProps = {
    children: ReactNode;
};

// const defaultConfigurationsContext: ConfigurationsContextType = { 
//     optionGroups: [],
//     configurationID: -1,
//     setConfigurationID: () => {},
//     setOptionGroups: () => {}
//  };

const defaultConfigurationsState: ConfigurationsStateType = { 
    configurations: [],
    configurationID: -1,
 };


export function ConfigurationsContextProvider({ children }: ConfigurationsContextProviderProps) {

    const [configurationsContextState, dispatch] = useReducer(reducer, {
        configurationID: undefined,
        configurations: undefined
    });
    const routeContext = useRouteContext();

    const setContextConfigurationID = useCallback((value: number) => {

        dispatch({
            type: ConfigurationsContextActionType.ConfigurationChanged,
            payload: value
        })

    }, [
        dispatch
    ]);

    const setContextConfigurations = useCallback((value: SideSheetGroupedSelectOptionGroup<number>[]) => {

        dispatch({
            type: ConfigurationsContextActionType.ConfigurationsChanged,
            payload: value
        })

    }, [
        dispatch
    ]);

    useEffect(() => {

        //console.log(`viewid: ${routeContext.viewID} and context: ${JSON.stringify(routeContext.contextObject)}`)
        // ignore the default summary listing view ID because it will be reset to the route/viewid for the active tab
        if (routeContext.viewID) {
            dispatch({
                type: ConfigurationsContextActionType.ResetChanged,
                payload: undefined
            });
        }
        
    },[
        routeContext.viewID,
        routeContext.contextObject,
        dispatch
    ]);


    return (
        <ConfigurationsContext.Provider value={{
            configurationsContextState, 
            setContextConfigurations,
            setContextConfigurationID
        }}>
            {children}
        </ConfigurationsContext.Provider>
    );
}